// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabLayout_tab__tPLmp","tab-title":"TabLayout_tab-title__S4pI6","tab-content":"TabLayout_tab-content__PDLjj","tab-breadcrumb":"TabLayout_tab-breadcrumb___CMfj"};